import { createRoot } from 'react-dom/client'
import type { Config } from '@tivio/sdk-react'
import { LangCode, renderWebPlayer, createTivio, TivioProvider, setUser, setSdkReactConfig, SourceType, SourcePlayMode } from '@tivio/sdk-react'
import type { VodExternalSourceParams } from '@tivio/types'
import './index.css'
import reportWebVitals from './reportWebVitals'
import App from './App'

const tivioConf: Config = {
    // secret: "JF2e5QRCUa1mcH2sHaeC", // tiv.io prod
    // secret: 'GjvTxnJDrH5CjU7x4JZA', // Oktagon TIZEN Prod
    // secret: '63c965a8b2e1605402be4026e737c58d', //  Oktagon web PROD
    secret: 'K82UxzHTK_njk28PmSNa', // Efabrica JOJ Prod
    // bundleUrlOverride: "path/to/core-react-dom-bundle",
    verbose: true,
    deviceCapabilities: [],
    currency: 'EUR',
    language: LangCode.EN,
    customTokenCookiesDomain: 'tivio.studio'
    // customTokenCookiesDomain: 'localhost'
}

const init =  async () => {
    const tivio = await createTivio()(tivioConf)
}

// const init = async () => {
//     const tivio = await createTivio()(tivioConf)
//     console.log('Tivio SDK initialized', tivio)
//
//     const videoId = 'gMSBWYAFEjLJjejGKiIr' // Example video ID, replace with actual video ID
//
//     // console.log('example-sdk: Looking up video with ID:', videoId)
//     // const videoData = await tivio.getVideoById?.(videoId)
//
//     // if (!videoData) {
//     //     // throw new Error('Video not found')
//     //     console.error('Video not found')
//     // } else {
//     //     const simpleVideo = {
//     //         id: videoData.id || '',
//     //         title: videoData.name,
//     //         description: videoData.description || '',
//     //         image: videoData.image || '',
//     //         stream: '',
//     //     }
//     //     console.log('example-sdk:Simple Video:', simpleVideo)
//     // }
//
//     const player = document.querySelector('#player-1') as HTMLElement
//     // const player2 = document.querySelector('#player-2') as HTMLElement
//
//     // setSdkReactConfig(tivioConf)
//     const playerMainController = await renderWebPlayer(player, {
//         id: 'player-main',
//         autoplay: true,
//         isSameSizeAsParent: true,
//         isMutedByDefault: true, // add to README
//         doNotSaveWatchPosition: true, // add to README
//         source: 'videos/CIxrI5uJC3JNhYAwcuPt',
//         // source: 'tvChannels/LYyAwEjjqmj8kMY23Lqw'
//         // source: {
//         //     type: SourceType.VOD_EXTERNAL,
//         //     url: 'https://dash.akamaized.net/akamai/bbb_30fps/bbb_30fps.mpd',
//         //     sourcePlayMode: SourcePlayMode.ON_DEMAND,
//         //     poster: 'https://storage.googleapis.com/tivio-production-input-admin/organizations%2Fx720GbG3Jys0ZEdLYr2j%2Fvideos%2FPlJ9s6o60uh1mZbQQeJV%2Fcover%2F%402-1702543759864.png',
//         //     name: 'Big Buck Bunny',
//         // },
//     })
//
//     playerMainController.addEventListener('statechange', (state) => {
//         console.log('Player state:', state) // 'playing', 'paused', 'idle'
//     })
//
//     // Time updates
//     playerMainController.addEventListener('timeupdate', (currentTime) => {
//         console.log('Current time:', currentTime)
//     })
//
//     // Video ended
//     playerMainController.addEventListener('video_unit_ended', () => {
//         console.log('Video playback ended')
//     })
//
//     // Duration changes
//     playerMainController.addEventListener('durationchange', (duration) => {
//         console.log('Video duration:', duration)
//     })
//
//     // Volume changes
//     playerMainController.addEventListener('volumechange', ({ muted, volume }) => {
//         console.log('Volume changed:', { muted, volume })
//     })
//
//     // Buffering state
//     playerMainController.addEventListener('bufferingchange', (isBuffering) => {
//         console.log('Buffering:', isBuffering)
//     })
//
//     // Errors
//     playerMainController.addEventListener('error', (error) => {
//         console.error('Playback error:', error)
//     })
//
//     // Create source cycling functionality
//     const sources = [
//         {
//             name: 'Video 1',
//             source: 'videos/rcWm3LtMu61ogW7l4PuM'
//         },
//         {
//             name: 'TV Channel',
//             source: 'tvChannels/LYyAwEjjqmj8kMY23Lqw'
//         },
//         {
//             name: 'External Video',
//             source: {
//                 type: SourceType.VOD_EXTERNAL,
//                 url: 'https://dash.akamaized.net/akamai/bbb_30fps/bbb_30fps.mpd',
//                 sourcePlayMode: SourcePlayMode.ON_DEMAND,
//                 poster: 'https://storage.googleapis.com/tivio-production-input-admin/organizations%2Fx720GbG3Jys0ZEdLYr2j%2Fvideos%2FPlJ9s6o60uh1mZbQQeJV%2Fcover%2F%402-1702543759864.png',
//                 name: 'Big Buck Bunny',
//                 autoplay: false,
//                 continuePositionMs: 10000,
//             } as VodExternalSourceParams
//         }
//     ]
//
//     let currentSourceIndex = 0
//
//     // Create buttons container
//     const buttonsContainer = document.createElement('div')
//     // TODO: Move styles to CSS file
//     buttonsContainer.style.cssText = `
//         position: fixed;
//         top: 20px;
//         right: 20px;
//         z-index: 1000;
//         background: rgba(0, 0, 0, 0.8);
//         padding: 15px;
//         border-radius: 8px;
//         display: flex;
//         flex-direction: column;
//         gap: 10px;
//     `
//
//     // Create cycle button
//     const cycleButton = document.createElement('button')
//     cycleButton.textContent = 'Cycle Source'
//     cycleButton.style.cssText = `
//         padding: 10px 15px;
//         background: #007bff;
//         color: white;
//         border: none;
//         border-radius: 4px;
//         cursor: pointer;
//         font-size: 14px;
//         font-weight: bold;
//     `
//     cycleButton.addEventListener('click', () => {
//         currentSourceIndex = (currentSourceIndex + 1) % sources.length
//         const newSource = sources[currentSourceIndex]
//         console.log(`Switching to: ${newSource.name}`)
//         playerMainController.setSource(newSource.source)
//         updateSourceInfo()
//     })
//
//     // Create source info display
//     const sourceInfo = document.createElement('div')
//     sourceInfo.style.cssText = `
//         color: white;
//         font-size: 12px;
//         margin-top: 10px;
//         padding: 8px;
//         background: rgba(255, 255, 255, 0.1);
//         border-radius: 4px;
//     `
//
//     function updateSourceInfo() {
//         const currentSource = sources[currentSourceIndex]
//         sourceInfo.textContent = `Current: ${currentSource.name}`
//     }
//
//     // Create individual source buttons
//     const individualButtons = sources.map((source, index) => {
//         const button = document.createElement('button')
//         button.textContent = source.name
//         button.style.cssText = `
//             padding: 8px 12px;
//             background: #28a745;
//             color: white;
//             border: none;
//             border-radius: 4px;
//             cursor: pointer;
//             font-size: 12px;
//         `
//         button.addEventListener('click', () => {
//             currentSourceIndex = index
//             console.log(`Switching to: ${source.name}`)
//             playerMainController.setSource(source.source)
//             updateSourceInfo()
//         })
//         return button
//     })
//
//     // Add elements to container
//     buttonsContainer.appendChild(cycleButton)
//     individualButtons.forEach(button => buttonsContainer.appendChild(button))
//     buttonsContainer.appendChild(sourceInfo)
//
//     // Add container to page
//     document.body.appendChild(buttonsContainer)
//
//     // Initialize source info
//     updateSourceInfo()
//
//     // @ts-ignore
//     window.testController = playerMainController
//     // await new Promise((resolve) => setTimeout(resolve, 5000))
//     // console.log('example-sdk: signing out current user')
//     // await setUser(null)
//     return tivio
// }
init().catch((error) => {
    console.error('Error initializing Tivio SDK', error)
})

const container = document.getElementById('root');
const root = createRoot(container!)
root.render(
    <TivioProvider conf={tivioConf}>
        <App />
    </TivioProvider>
);

// renderWebPlayer(player2, {
//     id: 'player-small',
//     source: 'videos/7MRfMiuzWWIlBn91xy7h',
// })

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
